export default {
  list: [
    {
      title: 'کاربرهای خاص',
      value: 'SPECIAL_USERS',
    },
  ],
  values: {
    SPECIAL_USERS: 'SPECIAL_USERS',
  },
};
